import { render, staticRenderFns } from "./wizard-launcher.vue?vue&type=template&id=10f7b868&scoped=true"
import script from "./wizard-launcher.vue?vue&type=script&lang=js"
export * from "./wizard-launcher.vue?vue&type=script&lang=js"
import style0 from "./wizard-launcher.vue?vue&type=style&index=0&id=10f7b868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7b868",
  null
  
)

export default component.exports